var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable } from 'mobx';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { withDefault } from '../../../utils/serializr/schema/middle/withDefault';
import { object } from '../../../utils/serializr/schema/object';
import { editable } from '../../../utils/mobx/decorators/editable';
import { Guidance } from '../guidance/Guidance';
export class IntroStore {
    parent;
    constructor({ parent }) {
        makeObservable(this);
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    guidance;
    static get serializeInfo() {
        return {
            props: {
                reward: withDefault(object(Guidance, { parentDepth: 2 }), {}),
            },
        };
    }
}
__decorate([
    editable()
], IntroStore.prototype, "guidance", void 0);
__decorate([
    memoize
], IntroStore, "serializeInfo", null);
